import { polish } from './pl-PL';
import { english } from './en-US';
import config from '../../config';

export const translations = {
    'en-GB': english,
    'pl-PL': polish,
};

export const currentTranslations = Object.values(translations).find(value => value.Key === config.language);
